import Swal from "sweetalert2";

// Top-right toast with a progress bar, built on the SweetAlert2 toast mode.
const PROGRESS_BAR_COLOR_BY_ICON = {
  success: "#0d6efd", // blue
  error: "#dc3545", // red
  warning: "#fd7e14", // orange
};

const fireToast = (icon, message) => {
  Swal.fire({
    toast: true,
    position: "top-end",
    icon,
    title: message,
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;

      const progressBar = toast.querySelector(".swal2-timer-progress-bar");
      if (progressBar) {
        progressBar.style.background = PROGRESS_BAR_COLOR_BY_ICON[icon] || progressBar.style.background;
      }
    },
  });
};

export const showSuccessToast = (message) => fireToast("success", message);
export const showErrorToast = (message) => fireToast("error", message);
export const showWarningToast = (message) => fireToast("warning", message);
